import { Leaderboard } from "@datagame/ui";
import { useParams } from "react-router-dom";
import { useQuery } from "@apollo/client";

import { CustomizedBackground } from "../../CustomizedBackground";
import { useGlobalConfiguration } from "../../../hooks/useGlobalConfiugration";

import styles from "../LeaderboardView.module.scss";
import { GET_PROJECT_LEADERBOARD, GET_PROJECT_LEADERBOARD_CURRENT_ROW } from "../../../graphql/queries/Project";

export interface LeaderboardViewProps {
  responseId?: string;
  onContinue?: () => void;
}

export const ProjectLeaderboardView = (props: LeaderboardViewProps) => {
  const { projectId } = useParams();
  const { onContinue } = props;
  const { leaderboardConfiguration, projectNickname } = useGlobalConfiguration();

  if (!projectId) {
    throw new Error(`Project with id ${projectId} not found`);
  }

  const { data: { projectLeaderboard = [] } = {} } = useQuery(GET_PROJECT_LEADERBOARD, {
    variables: {
      projectId,
    },
  });

  const limitedResults = projectLeaderboard.slice(0, leaderboardConfiguration.numberOfPlayers);

  const { data: { currentRow } = {} } = useQuery(GET_PROJECT_LEADERBOARD_CURRENT_ROW, {
    variables: {
      projectId,
      nickname: projectNickname,
    },
    skip: !projectNickname,
  });

  return (
    <CustomizedBackground config={leaderboardConfiguration} className={styles.leaderboardView}>
      <Leaderboard
        configuration={leaderboardConfiguration}
        results={limitedResults}
        currentRow={currentRow}
        onContinue={onContinue}
      />
    </CustomizedBackground>
  );
};
